import { Context } from 'Context/Context';
import axios from 'axios';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { getCaseType, getStringFromNumber, processReqReviewCount } from 'Utils';
import {  TOKEN, caseDetailsProfApi, caseRelRemoveApi, casesStatusUpdateApi, denyToCloseApi, denyToViewApi, downloadAttachmentsApi, getDocumentDownloadUrlApi, raiseNotificationApi, requestToCloseApi } from 'Constants';
import AdditionalInfoOnCaseDetails from './AdditionalInfoOnCaseDetails';
import CloseCaseModal from 'Modals/CloseCaseModal';
import { ToastContainer, toast } from 'react-toastify';
import ProfStepper from 'Stepper/ProfStepper';
import ReqToCloseBtns from './ReqToCloseBtns';
import {noConflictInterestedToViewApi} from 'Constants';
import {noConflictNotInterestedToViewApi} from 'Constants';
import AdditionalFieldsOnProfContent from './AdditionalFieldsOnProfContent';
import DocumentsDownloadOnProfContent from './DocumentsDownloadOnProfContent';
import RequiredInfoOnProfContent from './RequiredInfoOnProfContent';
import HeaderOnProfContent from './HeaderOnProfContent';
import DetailedStatusInfoOnProfContent from './DetailedStatusInfoOnProfContent';
import CasePendingInfoOnProfContent from './CasePendingInfoOnProfContent';
import LoadingGauge from 'Components/Icons/LoadingGauge';
import ReportCase from './ReportCase';
import RequestToViewBtn from './RequestToViewBtn';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import TeamUp from './TeamUp';
import TeamupInvitesReceived from './TeamupInvitesReceived';
import { TEAMUP_ENABLED } from 'Constants';


function ProfCaseDetailsContent({attorney, setRefreshList, setCloseMsg, setSingleCase, setCaseDetailsModalData, caseData, setUpdateComp, onClose, updateCaseResponse, caseId}) {
    const [caseDetails, setCaseDetails] = useState(null);
    const id = caseData?._id ? caseData?._id : caseId;
    const [isResponseReceived, setIsResponseReceived] = useState(null);
    const {userDetails, setUpdateLoggedinData,setShowLoading, makeApiCallFunc, reqRevCountArr, setReqRevCountArr} = useContext(Context);
    const userInfo = attorney ? attorney?.userId : userDetails;
    const downloadButtonRef = useRef(null);
    const [showModal, setShowModal] = useState(false);
    const [hasAccess, setHasAccess] = useState(true);
    const [isValid, setIsValid] = useState(true);
    const [isCaseOpen, setIsCaseOpen] = useState(true); 
    const [teamUpObj, setTeamUpObj] = useState(null);
    const [confirmedTeamUp, setConfirmedTeamUp] = useState(null);
    const [updateCaseDets, setUpdateCaseDets] = useState(true);
    console.log("caseDetails in prof case details content", caseData);
    const navigate = useNavigate();
    const setAccess = (data) => {
        
        if(!data?.caseStatus || data?.caseStatus === "requested" || data?.caseStatus === "approved" || data?.caseStatus === "denied")
        {
           return false;
        }
        return true;
    }
    const onReqToView = () => { 
        const caseId = caseData?.caseDetails?._id;
        const owner_id = caseData?.caseDetails?.owner;
        const noOfTimesReq = reqRevCountArr?.denied  ? reqRevCountArr?.denied : 0;
        makeApiCallFunc(
             casesStatusUpdateApi,
             {
                 caseId: caseId,
                 userId: userInfo._id,
                 assistantId: attorney ? userDetails._id : null,
                 caseStatus: "requested"
             },
             ({data}) => {
                //  console.log(data);

                 const notificationObj = {
                         title : (noOfTimesReq !== 0 ?   userDetails?.firstName +" "+ userDetails?.lastName + ( attorney !== undefined ?( " on behalf of the legal attorney " + userInfo?.firstName +" " +  userInfo.lastName) : '') + " has sent a request for the "+(noOfTimesReq)+" time to this case - " :  userDetails?.firstName +" "+ userDetails?.lastName + ( attorney ? " on behalf of the legal attorney " + userInfo?.firstName +" " +  userInfo.lastName : '') +" has sent a new request for your case - " )+getCaseType(caseData?.caseType),
                         is_read : false,
                         sender: "professional",
                         type: "3",
                         notificationCategory: 1,
                         caseNumber: caseData?.caseDetails?.caseNumber,
                         receiver:  owner_id,
                         additionalInfo : {
                             "caseId": caseId,
                             "userId": userDetails._id
                         },
                         content: 
                          userDetails.isUserFunder ?
                            "A verified Litigation Funder "+ userDetails?.company +"has requested to view your case details.  Please review the Litigation Funder's details and approve or deny their request."+ (noOfTimesReq !==0 ? " Note that the same Funder has requested to view this case for the "+ getStringFromNumber(noOfTimesReq+1) + " time" : '')
                            :
                            "A Verified Attorney "+ userDetails?.firstName +" "+ userDetails?.lastName +" has requested to view your case details. Please review the Attorney's details and approve or deny their request."+ (noOfTimesReq !==0 ? " Note that the same Attorney has requested to view this case for the "+ getStringFromNumber(noOfTimesReq+1) + " time" : '')
                            
                             }
                 makeApiCallFunc(
                    raiseNotificationApi, 
                    notificationObj, 
                     (data) => {
                        updateCaseResponse(caseId);
                        setRefreshList(true);
                        console.log(data);
                     },
                     (error) => console.log(error),
                     null,
                        true
                    )
             },
             (data) => {
                 console.log(data)},
                
         )
     }
    useEffect(() => {
        
        if(caseData)

        {
            console.log("prof case details content useeffect called", caseData)
            setCaseDetails(caseData.caseDetails);
            setHasAccess(setAccess(caseData));
            setIsCaseOpen(caseData.caseStatus !== "closed" ? true : false);
            setIsValid(caseData?.caseStatus !== "conflict" ? false : true)
        }
        else if(id)
        {
           console.log("prrofcasedetails content api call") 
            makeApiCallFunc(caseDetailsProfApi, 
                {
                    caseId: id,
                    userId: userInfo?._id,
                    isNotActiveUser: !userInfo?.isActiveSubscription
                },
            ({dat})=>
            {
               window.scrollTo(0,0);
               console.log("prof case details content api response", dat);
               let data = dat[0];
               setCaseDetails(data?.caseDetails);
               setHasAccess(setAccess(data));
               setIsCaseOpen(data?.caseStatus !== "closed" ? true : false);
               setIsValid(data?.caseToProfStatus === 6 ? false : true)
            },
            function (error) {
                console.log(error);
            })
            makeApiCallFunc(caseDetailsProfApi, 
                {
                    caseId: id,
                    userId: userInfo?._id,
                    loadReqRev: true,
                    isNotActiveUser: !userInfo?.isActiveSubscription
                },
              ({data})=>
              {
                setReqRevCountArr(data);  
              },
              function (error) {
                  console.log(error);
              }
            );
        }
    },[caseData, updateCaseDets]);
    const fetchFile = async (url) => {
        try {
            const response = await fetch(url);
          return await response.blob();
            
        } catch (error) {
            alert("Error in downloading files");
            console.log(error)
        }
        
      };
    // Case documents/video used to be stored on S3 with ACL: "public-read",
    // so `item.location` (with the query string stripped) was itself a
    // permanent public URL and could be fetched directly. Uploads are now
    // private, so each file needs a fresh, access-checked, short-lived URL
    // from the server before it can be fetched into the ZIP.
    // fileName is a display label, not guaranteed unique within a case -
    // location is, so it's sent too to disambiguate duplicate filenames.
    const getDownloadUrl = (documentTypeName, fileName, location) => new Promise((resolve) => {
        makeApiCallFunc(
            getDocumentDownloadUrlApi,
            { caseId: id, documentTypeName, fileName, location },
            ({ data }) => resolve(data?.url || null),
            (error) => { console.log(error); resolve(null); }
        );
    });
    const onDownload = async (isAttachments) => 
    {
        const files = [];
        let cas = caseDetails;
        setIsResponseReceived(true);
        
        if (downloadButtonRef.current && !isAttachments) {
            downloadButtonRef.current.click();
          }

        if(cas && cas?.supportingDocuments && cas?.supportingDocuments?.length)
        {
            cas.supportingDocuments.map((item) => {
                return files.push({ documentTypeName: 'supportingDocuments', fileName: item.fileName, location: item.location })
            })
        }
        if(cas && cas?.videoDocument && cas?.videoDocument?.length)
        {
            cas.videoDocument.map((item) => {
                return files.push({ documentTypeName: 'videoDocument', fileName: item.fileName, location: item.location })
            })
        }
        if(files.length !== 0 )
        {
                  const zip = new JSZip();
              
                  // Loop through the files, fetch a fresh signed URL for
                  // each, and add them to the ZIP.
                  await Promise.all(
                    files.map(async ({ documentTypeName, fileName, location }) => {
                      const url = await getDownloadUrl(documentTypeName, fileName, location);
                      if (!url) {
                        console.log('Could not get a download URL for', fileName);
                        return;
                      }
                      const fileBlob = await fetchFile(url);
                      console.log(fileBlob)
                      zip.file(fileName, fileBlob);
                    })
                  );
              
                  // Generate the ZIP file
                  zip.generateAsync({ type: 'blob' }).then((blob) => {
                    setIsResponseReceived(false);
                    saveAs(blob, getCaseType(cas?.caseType)+'.zip'); // Trigger the ZIP file download
                  });
                
            // const response = await axios.post(downloadAttachmentsApi,
            //     {
            //         "fileKeys": arr
            //     },
            // {
            // responseType: 'blob', 
            // });
            // if(response)
            // {
            //     setIsResponseReceived(false);
            //     const blob = new Blob([response.data], { type: 'application/zip' });
            //     const link = document.createElement('a');
            //     link.href = window.URL.createObjectURL(blob);
            //     link.download = getCaseType(cas?.caseType)+'.zip';
            //     document.body.appendChild(link);
            //     link.click();
            //     document.body.removeChild(link);
            //     return response;
            // }
            
        
    }
}
    const getCaseListNo = () =>{
        switch(caseDetails?.caseStatus)
        {
            case "requested" :
                return 2;
            case "approved" : 
            return 3;
            case "noConflict": 
            return 4;
            case "reqToClose":
                return 5;
                case "closed":
                    return 6
            default : 
            return 1;
        }
    }
    const getListName = () => {
        switch(caseDetails?.caseStatus)
        {
            case "requested" :
                return "all interested cases";
            case "approved" : 
            return "all approved cases";
            case "noConflict": 
            return "all no conflict cases";
            case "reqToClose":
                return "request to close cases";
                case "closed":
                    return "all closed cases"
            default : 
            return "all cases";
        }
    }
    const requestToCloseCase = () => {
        window.scrollTo(0,0);
        setShowModal(false);
        console.log("Request to close case called");
        console.log(teamUpObj);
        makeApiCallFunc(casesStatusUpdateApi,
            {
                caseId: caseData?.caseId,
                userId: userInfo._id,
                assistantId: attorney ? userDetails._id : null,
                caseStatus: "reqToClose",
                teamup: {
                    "fromUserId": teamUpObj?.fromUserId,
                    "toUserId": teamUpObj?.toUserId
                }
            },
            ({data})=>{
                
                // updateCaseResponse ? updateCaseResponse(id) : setUpdateCaseDets(prev => !prev);
                // setUserDetails((prev) => 
                // {
                //     return {...prev, casesCount: data}
                // })
                // onClose();
                caseStatusUpdateCallback(data)
                setRefreshList(true);
                setCloseMsg(caseData?.caseDetails?.caseNumber + " moved to closed cases list.");
                const notificationObj = {
                    title : "The Legal Attorney has requested to close your " + getCaseType(caseData?.caseDetails?.caseType) + " - " + caseData?.caseDetails?.caseNumber + ".",
                        is_read : false,
                        sender: "professional",
                    notificationCategory: 1,
                    caseNumber: caseData?.caseDetails?.caseNumber,
                    type: "3",
                        receiver:  caseData?.caseDetails?.owner,
                        additionalInfo : {
                            "caseId": caseData?.caseId,
                            "userId": userDetails?._id
                        },
                        content: "The " + getCaseType(caseData?.caseDetails?.caseType) + " - " + caseData?.caseDetails?.caseNumber + " is requested to be closed by the legal Attorney " + userInfo?.firstName + " " + userInfo?.lastName + ". Please approve only if you have signed the contract.",
                    }
               makeApiCallFunc(raiseNotificationApi, 
                notificationObj, 
                 (data) => console.log(data),
                 (error) => console.log(error)
                );
            //    setUpdateComp(prev => !prev);

                return;
            },
            (data)=>{
                
                console.log(data)
            },
            )
    }
    const caseStatusUpdateCallback = (data) => {
         const updatedcaseDets = data?.caseDetails?.root
        const updatedUserCase = data?.updatedUserCase

            
            if(updatedcaseDets)
            {
                    setCaseDetails(updatedcaseDets);
                    setCaseDetailsModalData({...updatedUserCase, caseDetails: updatedcaseDets});
                    setSingleCase({...updatedUserCase, caseDetails: updatedcaseDets});
                    setReqRevCountArr(processReqReviewCount(data?.userCaseStatusCount, userInfo));

                    setHasAccess(setAccess(updatedUserCase));
                    setIsCaseOpen(updatedUserCase.caseStatus !== "closed" ? true : false);
                    setIsValid(updatedUserCase?.caseStatus !== "conflict" ? false : true);

                    window.scrollTo(0,0);
                    
            }
            else
            {
            onClose();
            setUpdateComp(prev => !prev);

            }
        }
    const onRevert = () => {
        window.scrollTo(0,0);

            const postData = {
                caseId: caseData?.caseId,
                "userId" : userInfo._id,
                assistantId: attorney ? userDetails._id : null,
                caseStatus: "noConflict",
                sendResp : true
            }
            makeApiCallFunc(
                casesStatusUpdateApi,
                postData,
                ({data}) => {

                    // toast.success("Reverted the request");
                    caseStatusUpdateCallback(data)
                setRefreshList(true);
                    setCloseMsg(caseData?.caseDetails?.caseNumber + " moved to My Cases list.");

                    //setUpdateCaseDets(prev => !prev);
                    // updateCaseResponse ? updateCaseResponse(id) : setUpdateCaseDets(prev => !prev);
                    // setUserDetails((prev) => 
                    // {
                    //     return {...prev, casesCount: data}
                    // })
                    //notifyAllProf(true);

                    
                    const notificationObj = {
                    
                    title : "The Legal Attorney has reverted the request to close the case " + getCaseType(caseData?.caseDetails?.caseType) + " - " + caseData?.caseDetails?.caseNumber + ".",
                    is_read : false,
                    sender: "professional",
                    caseNumber: caseData?.caseDetails?.caseNumber,
                    notificationCategory: 1,
                    type: "4",
                    receiver:  caseData?.caseDetails?.owner,
                    additionalInfo : {
                        "caseId": caseData?.caseId,
                        "userId": userDetails?._id
                    },
                    content: "The " + getCaseType(caseData?.caseDetails?.caseType) + " - " + caseData?.caseDetails?.caseNumber + " is open again because professional reverted the request to close the case.",

                         }

                   return makeApiCallFunc(raiseNotificationApi, 
                    notificationObj, 
                     (data) => console.log(data),
                     (error) => console.log(error)
                    );
        
                },
                (data) => {
                    console.log(data)
                }
            )
            
        
    }
    const withdrawReq = () => { 
        
        makeApiCallFunc(
           caseRelRemoveApi,
            {
                caseId: caseData?.caseDetails?._id,
                userId: userInfo._id
            },
            ({data}) => {
                setRefreshList(true);
                updateCaseResponse(caseData?.caseDetails?._id)
            },
            (data) => {
                console.log(data)},
        )
    }
     const notInterested = (e) => {

              makeApiCallFunc(
                  noConflictNotInterestedToViewApi,
                  {
                      caseId: caseDetails?._id,
                      userId: userInfo?._id,
                      assistantId: caseData?.assistantId?.[0]?._id,
                      type: caseData?.caseStatus
                  },
                  (data) => {
                      //setIsInterested((prev) => !prev);
                      setRefreshList(true);
                      console.log(data);
                      setCloseMsg(caseData?.caseDetails?.caseNumber + " moved to not interested Cases list.");

                      // toast.success("Client has been notified.");
                      const notificationObj = {
                        title : "Legal Attorney "+userDetails?.firstName+" "+userDetails?.lastName+" who cleared conflict has marked your case " + getCaseType(caseDetails?.caseType) + " - " + caseDetails?.caseNumber + " as not interested",
                        is_read : false,
                        sender: "professional",
                        notificationCategory: 1,
                        type: "3",
                        receiver:  caseDetails?.owner,
                        additionalInfo : {
                            "caseId": caseDetails?._id,
                            "userId": userDetails._id
                        },
                        content: "A verified Legal Attorney "+ userDetails?.firstName +" "+ userDetails?.lastName +" has marked your case " + getCaseType(caseDetails?.caseType) + " - " + caseDetails?.caseNumber + " as not interested. We will continue to notify you with more attorneys as and when they show interest",
                        }
                        makeApiCallFunc(raiseNotificationApi, 
                            notificationObj, 
                            (data) => console.log(data),
                            (error) => console.log(error)
                            )
                           // setUpdateComp(prev => !prev);
                            updateCaseResponse(caseDetails?._id)
                            toast.info(caseData?.caseDetails?.caseNumber + " moved to not interested cases list.");
                  },
                  (data) => console.log(data),
              )
      }
      const interested = (e) => {
              makeApiCallFunc(
                  noConflictInterestedToViewApi,
                  {
                    caseId: caseDetails?._id,
                    userId: userInfo?._id,
                    assistantId: caseData?.assistantId?.[0]?._id,
                    type: caseData?.caseStatus
                  },
                  (data) => {
                      console.log(data);
                          setRefreshList(true);
                      console.log(data);
                      setCloseMsg(caseData?.caseDetails?.caseNumber + " moved to My Cases list.");

                      // toast.success("Client has been notified.");
                          const notificationObj = {
                              title : "Professional "+userDetails?.firstName+" "+userDetails?.lastName+" has availability to view your case " + getCaseType(caseDetails?.caseType) + " - " + caseDetails?.caseNumber,
                              is_read : false,
                              sender: "professional",
                              type: "3",
                          notificationCategory: 1,
                          receiver:  caseDetails?.owner,
                              additionalInfo : {
                                  "caseId": caseDetails?._id,
                                  "userId": userDetails._id
                              },
                              content: "A verified Legal Professional "+ userDetails?.firstName +" "+ userDetails?.lastName +" has marked your case " + getCaseType(caseDetails?.caseType) + " - " + caseDetails?.caseNumber + " as interested.",
                              }
                      makeApiCallFunc(raiseNotificationApi, 
                                  notificationObj, 
                                   (data) => console.log(data),
                                   (error) => console.log(error)
                                  )
                                 // setUpdateComp(prev => !prev); - coz it was closing the popup
                                  updateCaseResponse(caseDetails?._id)
                     toast.info(caseData?.caseDetails?.caseNumber + " moved to My Cases list.");

      
                  },
                  (data) => {
                      console.log(data)},
              )
      }
  return (
    <>
    {(caseDetails) ?
        
        <>
        {
            caseData?.caseStatus !== "conflict" || !caseData?.caseStatus ? 
                <>
                {
                showModal &&
                <CloseCaseModal
                uploadNew={showModal}
                userInfo={userInfo}
                caseDetails={caseDetails}
                confirmedTeamUp={confirmedTeamUp}
                setTeamUpObj={setTeamUpObj}
                teamUpObj={teamUpObj}
                onClose={()=>{
                    window.scrollTo(0,0);
                    toast.error("You have to sign contract to close this case")
                    setShowModal(false)
                    }
                }
                onSubmit={requestToCloseCase}
                />
                }
                <div className='w-full'>
                        
                        <div onClick={
                            ()=>
                            {
                                if(onClose) 
                                {
                                onClose() 
                                }
                                else
                                {
                                    navigate("/attorney/casesFeed/"+getCaseListNo())
                                }
                            }
                        }>
                        </div>
                        <div className='bg-white w-full border text-sm'>
                            {caseData?.caseStatus === "denied" 
                            
                            ?
                            <div className='font-bold text-sky-600 p-2 mb-4 '>
                                You were denied access to this case by the client. 
                                <br/>However you can request again..
                            </div>
                            :
                            <>

                            <HeaderOnProfContent
                            reqRevCountArr={reqRevCountArr}
                            setRefreshList={setRefreshList}
                            setCloseMsg={setCloseMsg}
                            onDownload = {onDownload}
                            caseData = {caseData}
                            setConfirmedTeamUp={setConfirmedTeamUp}
                            downloadButtonRef = {downloadButtonRef}
                            hasAccess={hasAccess}
                            caseDetails={caseDetails}
                            isCaseOpen={isCaseOpen}
                            onClose={onClose}
                            onMainModalClose={onClose}
                            updateCaseResponse={updateCaseResponse}
                            setUpdateComp={setUpdateComp}
                            attorney ={attorney}
                            isResponseReceived={isResponseReceived}
                            />
                            </>
                            }
                            
                            <div className='w-full rounded  flex flex-col  justify-between'>
                                    {caseData?.caseStatus !== "denied" &&
                                    <div className=''>
                                    <div className='flex items-center justify-center mt-4'>
                                        <CasePendingInfoOnProfContent caseDetails={caseData} reqRevCountArr={reqRevCountArr} userInfo={userInfo}/>
                                    </div>
                                        {caseData?.caseStatus &&
                                       <> <ProfStepper
                                        currentStep={caseData}
                                        isCaseOpen={isCaseOpen}
                                        />
                                        <DetailedStatusInfoOnProfContent 
                                        setRefreshList={setRefreshList}
                                        userInfo={userInfo}
                                        attorney={attorney}
                                        onClose={onClose}
                                        caseDetails={caseData}
                                        isCaseOpen={isCaseOpen}
                                        setCloseMsg={setCloseMsg}
                                        setUpdateComp={setUpdateComp}
                                        setUpdateCaseDets = {setUpdateCaseDets}
                                        updateCaseResponse={updateCaseResponse}
                                        />
                                        </>
                                        }
                                        
                
                                    </div>
                                    }
                                    {/* team up sending request is only for attorneys */}
                                    {
                                    //for attorneys only and case is no conflict
                                    TEAMUP_ENABLED && userInfo && userInfo?.isActiveSubscription && (!userInfo?.isUserFunder || userInfo?.isUserFunder === false) && caseData?.caseStatus === "noConflict" &&
                                    <TeamUp caseDetails={caseDetails} userInfo = {userInfo} 
                                        setConfirmedTeamUp={setConfirmedTeamUp}
                                        setUpdateComp={setUpdateComp}
                                        setRefreshMainList={setRefreshList} // cos refresh main list when prof details screen its changed
                                        isCaseReqToClose = {reqRevCountArr?.[caseDetails?._id]?.reqToClose  ? true : false}
                                    />
                                    }
                                    {
                                    //for funders only
                                    TEAMUP_ENABLED && userInfo && userInfo?.isUserFunder === true 
                                    && caseData?.caseStatus !== "reqToClose" && caseData?.caseStatus !== "closed" &&
                                    <TeamupInvitesReceived
                                        caseDetails={caseDetails}
                                        userInfo={userInfo}
                                        caseStatus={caseData?.caseStatus}
                                        setConfirmedTeamUp={setConfirmedTeamUp}
                                    />
                                    
                                    }
                                    <div className={'flex w-full ' + (!hasAccess ? '' : 'lg:flex-row flex-col')}>
                                        
                                        <RequiredInfoOnProfContent
                                        caseDetails={caseDetails}
                                        attorney={attorney}
                                        hasAccess={hasAccess}
                                        />
                                        {hasAccess ?
                                        <DocumentsDownloadOnProfContent
                                        onDownload={onDownload}
                                        caseDetails={caseDetails}
                                        isResponseReceived={isResponseReceived}
                                        />
                                        :
                                        ''
                                        }
                                    </div>
                                    {
                                        (caseData?.caseStatus === "denied" ||  caseData?.caseStatus === undefined) ?
                                            <div className='w-full flex text-xl justify-center mt-6 mb-6'>
                                                <RequestToViewBtn onReq={() => onReqToView()}/>
                                            </div>
                                        :
                                        caseData?.caseStatus === "requested" ?
                                        <div className='w-full flex justify-center mt-6 mb-6 items-center'>
                                        <div className='px-4 p-2 w-full justify-center lg:w-max w-max text-md text-sm bg-gray-600 text-white rounded cursor-pointer'
                                        onClick={() => withdrawReq()}
                                            >Withdraw your request</div>
                                            </div>
                                            :
                                           null

                                            
                                    }
                                    {hasAccess &&
                                    <>
                                    <AdditionalInfoOnCaseDetails caseDetails={caseDetails}/>
                                    <AdditionalFieldsOnProfContent caseDetails={caseDetails}/>
                                    {caseData?.caseStatus !== "closed" &&
                                        <div className='lg:flex-row flex-col items-center gap-2 lg:px-0 px-[20px] flex mt-10 mb-8 justify-center w-full  '>
                                            <ReqToCloseBtns caseDetails={caseData} setShowModal={setShowModal} onRevert={onRevert} userInfo={userInfo} />
                                            
                                            {caseData.caseInterest === 1 ?
                                                <div className='px-4 p-2 w-full justify-center lg:w-[300px]  lg:text-sm text-sm bg-sky-600 text-white rounded cursor-pointer flex lg:mr-2'
                                                onClick={()=> interested()}
                                                >
                                            Mark this as interested
                                            </div>
                                            :
                                            <div className='px-4 p-2 w-full justify-center lg:w-[300px] text-xs lg:text-sm   text-sm bg-red-600 text-white rounded cursor-pointer  flex lg:mr-2'
                                            onClick={(e) => notInterested(e)}
                                            >Mark this as not interested</div>
                                            }
                                            <ReportCase caseDetails={caseData} 
                                                attorney={attorney}
                                                updateCaseResponse={updateCaseResponse}
                                                setUpdateCaseDets={setUpdateCaseDets}
                                                setUpdateComp={setUpdateComp}
                                                onMainModalClose={onClose}
                                                setRefreshList={setRefreshList}
                                                />
                                        </div>
                                        }
                                    </>
                                    }
                            </div>
                        </div>
                </div>
                </>
                :
                <div className='mt-20 font-bold text-red-600'>You cannot view this case details anymore, you marked this as conflict !</div>
        }
        </>
    :
    <LoadingGauge/>
    }
    </>
    
   
        
  )
}

export default ProfCaseDetailsContent;